// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import { getUrlParamsObj } from '../../utils/route';

function isValidZendeskUrl(url) {
  return /^https?:\/\/support.fubo.tv\//.test(url);
}

export function extractUrlParams(): { [string]: string } {
  const params = getUrlParamsObj();
  const returnTo = isValidZendeskUrl(params.return_to) ? params.return_to : 'https://support.fubo.tv/hc/en-us';
  return {
    returnTo,
  };
}
